import { applyMiddleware, createStore, combineReducers, compose } from "redux";
import thunk from "redux-thunk";
import { routerReducer } from "react-router-redux";
import resetEnhancer from "../enhancer/reset.js";
import { reducer as loadingReducer } from "../components/loading";

import { reduxFirestore, getFirestore } from "redux-firestore";
import { reactReduxFirebase, getFirebase } from "react-redux-firebase";
import fbConfig from "../config/fbConfig";
import { firebaseReducer } from "react-redux-firebase";
import authReducer from "./reducers/authReducer";

const originalReducers = {
  auth: authReducer,
  loading: loadingReducer,
  routing: routerReducer,
  firebase: firebaseReducer
};
const reducer = combineReducers(originalReducers);
const win = window;
const middlewares = [thunk];

if (process.env.NODE_ENV !== "production") {
  middlewares.push(require("redux-immutable-state-invariant").default());
}

const storeEnhancers = compose(
  resetEnhancer,
  reactReduxFirebase(fbConfig, {
    userProfile: "students",
    useFirestoreForProfile: true,
    attachAuthIsReady: true
  }), // redux binding for firebase
  reduxFirestore(fbConfig), // redux bindings for firestore
  applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore })),
  win && win.devToolsExtension ? win.devToolsExtension() : f => f
);

const initialState = {};
const store = createStore(reducer, initialState, storeEnhancers);
store._reducers = originalReducers;
export default store;
